export default __webpack_public_path__ + "static/media/rodrigo-ardilha.7882a7ca.jpg";